import { Label } from "@mui/icons-material";
/*
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
*/

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { GridColumns } from "@mui/x-data-grid";
import br from "date-fns/locale/pt-BR";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";

import style from "./DownloadCSVStyle.module.css";

export default function DownloadCSVModalDetalhe(
  props: DownloadCSVModalDetalhePropsTypes
) {
  const [separador, setSeparador] = useState<string>(";");
  const [customSeparador, setCustomSeparador] = useState<string>("");

  const [modoVisualizacao, setModoVisualizacao] = useState<boolean>(false);

  const exemploOriginal = `linha 1@linha 2@linha 3`;
  const [exemplo, setExemplo] = useState<string>(`linha 1@linha 2@linha 3`);

  const nomeArquivo = props.name
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .replaceAll(" ", "_");

  const csvData = props.rows.map((item) => {
    return Object.fromEntries(
      Object.entries(item).map(([k, v]) => {
        switch (typeof v) {
          case "boolean":
            v = v == true ? "Sim" : "Não";
            break;
          case "object":
            v = v instanceof Date ? new Date(v).toLocaleDateString("pt-BR") : v;
            break;
          // case "number":
          //   v = v.toLocaleString("pt-BR");
          //   break; 
        }
        return [k, v];
      })
    );
  });

  const csvHeader = props.columns.map((item, index) => {
    item.field = index == 0 ? "id" : item.field;
    return { label: item.field!, key: item.field! };
  });

  const csvHeaderVisualizacao = props.columns.map((item) => {
    return { label: item.headerName!, key: item.field! };
  });
  const csvLinkEl = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setExemplo(
      separador == "outro"
        ? exemploOriginal.replaceAll("@", customSeparador)
        : exemploOriginal.replaceAll("@", separador)
    );
  }, [separador, customSeparador]);

  useEffect(() => {}, []);

  function handleSeparadorChange(value: string) {
    setSeparador(value == "tab" ? "\t" : value);
  }

  function handleCustomSeparadorChange(e: any) {
    setCustomSeparador(e.target.value ? e.target.value[0] : "");
  }

  function handleBaixarCSVClick() {
    csvLinkEl!.current!.click();
  }

  function handleModoVisualizacaoClick(e: any): void {
    setModoVisualizacao(e.target.checked);
  }

  function dataHoje(): string {
    return new Date()
      .toLocaleDateString("pt-BR", { hour: "2-digit", minute: "2-digit" })
      .replaceAll("/", "_")
      .replaceAll(" ", "_");
  }

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          height={"65vh"}
          alignItems={"end"}
          margin={"0.5rem"}
        >
          <FormControl fullWidth>
            <FormLabel>Separador:</FormLabel>
            <RadioGroup
              defaultValue=";"
              name="radio-buttons-separador"
              row
              sx={{ display: "flex", justifyContent: "space-evenly" }}
              onChange={(e, value) => handleSeparadorChange(value)}
            >
              {/* <FormControlLabel value="," control={<Radio />} label="," /> */}
              <FormControlLabel value=";" control={<Radio />} label=";" />
              <FormControlLabel value="tab" control={<Radio />} label="Tab" />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FormControlLabel
                  value="outro"
                  control={<Radio />}
                  label="Outro:"
                />
                <TextField
                  sx={{ width: "6em" }}
                  variant="filled"
                  disabled={separador !== "outro"}
                  onChange={(e) => handleCustomSeparadorChange(e)}
                  value={customSeparador}
                />
              </Box>
            </RadioGroup>

            <Box>
              <FormLabel>Exemplo do arquivo gerado:</FormLabel>
              <div className={style.downloadcsv__exemplo_arquivo}>
                <pre>{exemplo}</pre>
              </div>
            </Box>

            <FormControlLabel
              control={<Checkbox defaultChecked />}
              checked={modoVisualizacao}
              label="Modo Visualização"
              onChange={(e) => handleModoVisualizacaoClick(e)}
            />

            {modoVisualizacao ? (
              <Box paddingTop={"1rem"}>
                <Alert severity="warning">
                  O Modo Visualização foi pensado para ter seus dados
                  apresentados de uma forma mais legível. A edição dos valores
                  do Modo Visualização não funcionará para o Upload! Para baixar
                  um CSV que te permita editar os valores para enviá-los através
                  de upload, desmarque o Modo Visualização.
                </Alert>
              </Box>
            ) : null}
          </FormControl>

          <Button variant="contained" onClick={handleBaixarCSVClick}>
            Baixar CSV
          </Button>
        </Box>
      </LocalizationProvider>
      <CSVLink
        data={csvData}
        headers={modoVisualizacao == true ? csvHeaderVisualizacao : csvHeader}
        enclosingCharacter={""}
        filename={`${
          modoVisualizacao == true ? "vis_" : ""
        }${nomeArquivo}_${dataHoje()}`}
        separator={separador == "outro" ? customSeparador : separador}
        style={{ display: "none" }}
      >
        <div ref={csvLinkEl}></div>
      </CSVLink>
    </>
  );
}

interface DownloadCSVModalDetalhePropsTypes {
  handleClose: any;
  name: string;
  rows: any[];
  columns: GridColumns;
}
